/* eslint-disable no-restricted-globals */

// adapted from https://final-form.org/docs/react-final-form/examples/field-level-validation
export const composeValidators = (...validators: any[]) => (value: any) => validators.reduce((error, validator) => error || validator(value), undefined);
export const required = (value: any) => value || value === 0 ? undefined : 'Required';
export const mustBeNumber = (value: any) => value && isNaN(value) ? 'Must be a number' : undefined;
export const minValue = (min: any) => (value: any) => isNaN(value) || value >= min ? undefined : `Must be greater than ${min}`;
